export { default } from "./Avatar.mjs";
export { default as avatarClasses } from "./avatarClasses.mjs";
export * from "./avatarClasses.mjs";